import { AppAuthProvider } from '@/auth/AppAuthProvider'
import UserProvider from '@/user/UserProvider'
import AccountProvider from '@/account/AccountProvider'
import { AppContainer } from './AppContainer'
import { useFeatureFlags } from '../featureFlags/featureFlags'
import { DowntimeAlert } from './DowntimeAlert'
import { IntercomWidget } from '../intercom/IntercomWidget'
import AutoApplyUpdate from '@/common/pwa/AutoApplyUpdate'
import { useState } from 'react'
import { PwaProvider } from '../pwa/pwaProvider'
import { useUser } from '@/user/useUser'

const RootContainerInner = () => {
    const user = useUser()

    return (
        <AccountProvider user={user}>
            <AutoApplyUpdate />
            <PwaProvider>
                <AppContainer />
            </PwaProvider>
        </AccountProvider>
    )
}

export const RootContainer = () => {
    const { showDownTimePage } = useFeatureFlags()
    const [showMessageWidget, setShowMessageWidget] = useState<boolean>(false)

    const handleSendMessage = () => {
        setShowMessageWidget(true)
    }

    const handleHideWidget = () => {
        setShowMessageWidget(false)
    }

    return (
        <>
            {showDownTimePage ? (
                <DowntimeAlert onSendMessage={handleSendMessage} />
            ) : (
                <AppAuthProvider>
                    <UserProvider>
                        <RootContainerInner />
                    </UserProvider>
                </AppAuthProvider>
            )}
            <IntercomWidget showWidget={showMessageWidget} onHideWidget={handleHideWidget} />
        </>
    )
}
